module.exports = __webpack_public_path__ + "static/img/about_cooperate_03_zhdel.48c18aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_cooperate_03_zhdel.png
// module id = 12KE
// module chunks = 34